import {t} from '@lingui/macro';
import theme from 'config/theme';
import {Button} from 'interface/base/Button';
import {Icon} from 'interface/base/Icon';
import Typography from 'interface/base/Typography';
import {StyleSheet, View} from 'react-native';

type Props = {
  handleUpload: () => void;
};

export const FolderEmptyState = ({handleUpload}: Props) => {
  return (
    <View style={styles.root}>
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <Icon
            name="lucide:upload"
            size={24}
            color={theme.colors.neutral.$0}
          />
        </View>
        <View style={styles.textContainer}>
          <Typography
            color={theme.colors.neutral.$0}
            variant="semi-bold"
            size="lg">
            {t`Upload some files `}
          </Typography>
          <Typography
            color={theme.colors.neutral.$0}
            size="sm"
            variant="medium">
            {t`Drop files here or click the upload button.`}
          </Typography>
        </View>
        <Button onPress={handleUpload}>{t`Upload Files`}</Button>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  content: {
    padding: 24,
    borderRadius: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center',
    gap: 16,
    backgroundImage:
      'linear-gradient(90deg, #1428E0 0%, #2A0065 50%, #1C0144 100%)',
  },
  iconContainer: {
    display: 'flex',
    width: 64,
    height: 64,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(43, 234, 255, 0.10)',
    backgroundColor: 'rgba(146, 244, 255, 0.15)',
    backdropFilter: 'blur(7.5px)',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    paddingVertical: 5,
    justifyContent: 'center',
    width: 362,
  },
});
